// Action types
export const SET_THEME = 'SET_THEME';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_LOADING = 'SET_LOADING';

// Initial state
const initialState = {
  theme: 'light', // 'light' or 'dark'
  language: 'en', // 'en', 'ru', or 'bg'
  location: null, // { lat: number, lng: number }
  loading: false,
};

// Reducer
const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case SET_LOCATION:
      return {
        ...state,
        location: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;